export default [
  '/logos/logo-1.png',
  '/logos/logo-2.png',
  '/logos/logo-3.png',
  '/logos/logo-4.png',
] as string[];